import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import builderlogo from '../../images/builder-logo.png';
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import LoadingSkeleton from "../common/LoadingSkeleton";
import { useDispatch, useSelector } from 'react-redux';
import { fetchDistricts } from '../../redux/districtsSlice';
import { AppContext } from '../../context/AppContext';
import Advertisement from "../Advertisement";
import noImage from '../../images/no_image.jpg';
import PropertySideBar from "./PropertySideBar";

const PropertyListPg = () => {

    const { user } = useContext(AppContext);
    const { isAuthenticated, logout } = useContext(AppContext);
    const [filters, setFilters] = useState({});
    const [locality, setLocality] = useState('');
    const dispatch = useDispatch();
    const { districts, status, error1 } = useSelector((state) => state.districts);
  
    useEffect(() => {
      if (status === 'idle') {
        dispatch(fetchDistricts());
      }
    }, [dispatch, status]);
  
  
    const [isMenuOpen, setIsMenuOpen] = useState(false);
  
    const toggleMenu = () => {
      setIsMenuOpen((prev) => !prev);
    };
  
    const [isOpen, setIsOpen] = useState(false);
    
      const toggleAccordion = () => {
        setIsOpen(!isOpen); // Toggle the state on button click
    };
  
  
      const [selectedItems, setSelectedItems] = useState([]);
      
          const handleSelect = (label) => {
              setSelectedItems((prevSelected) =>
                  prevSelected.includes(label)
                      ? prevSelected.filter((item) => item !== label) // Remove if already selected
                      : [...prevSelected, label] // Add if not selected
              );
          };
  
  
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingSidebar, setLoadingSidebar] = useState(true);
    const [uniquePropertyTypes, setUniquePropertyTypes] = useState([]);
    const location = useLocation();
    const param = location.state;
    const [paginationInfo, setPaginationInfo] = useState({
      currentPage: 1,
      lastPage: 1,
      total: 0,
    });
  
    const cId = location.pathname.split("/").pop(); // Extract cId from the URL
  
    const service = location.pathname.split("/")[1]; // Extract service from the URL
  
  
    useEffect(() => {
      // Filter the districts based on cIdf
  
      const filteredDistricts = districts.filter((district) => district.id === parseInt(cId));
  
  
      setLocality(filteredDistricts[0]?.name); // Set the filtered districts to locality
    }, [districts, cId]);
    // Fetch data from the API
    const fetchPropertyData = async (cId, page = 1, perPage = 2) => {
      setLoading(true)
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/residential/search-rent/${cId}?service=${service}`,
          {
            params: {
              page, // Current page 
              per_page: perPage, // Items per page
              filters
            },
          }
        );
  
        if (response.data.status === 'success') {
  
  
          setList(response.data.data.properties); // Set the property list
  
          // const uniqueTypes = [...new Set(response.data.data.properties.map(item => item.property_type))];
          // setUniquePropertyTypes(uniqueTypes);
  
  
          setPaginationInfo({
            currentPage: response.data.data.current_page,
            lastPage: response.data.data.last_page,
            total: response.data.data.total,
            perPage: perPage,
          });
  
          setLoading(false)
        } else {
          setList([]);
          setLoading(false)
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setList([]);
        setLoading(false)
      }
    };
  
    // Trigger data fetch when the component mounts or when cId or currentPage changes
    useEffect(() => {
      fetchPropertyData(cId, paginationInfo.currentPage);
    }, [cId, paginationInfo.currentPage, filters]);
  
  
    const formatPrice = (price) => {
      if (price >= 10000000) {
        // Format as crore (cr)
        return (price / 10000000).toFixed(1).replace(/\.0$/, '') + 'cr';
      } else if (price >= 100000) {
        // Format as lakh (L)
        return (price / 100000).toFixed(1).replace(/\.0$/, '') + 'L';
      } else if (price >= 1000) {
        // Format as thousand (k)
        return (price / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
      } else {
        // Return price as is
        return price;
      }
    };
  
    const fetchSidebarData = async (type) => {
  
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/sidebar/getPropertySidebar?cId=${cId}&type=${type}`);
  
        if (response.data.status === 'success') {
          setUniquePropertyTypes(response.data.data)
          setLoadingSidebar(false)
  
        }
        else {
          setLoadingSidebar(false)
        }
  
  
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoadingSidebar(false)
      }
    };
    const token = localStorage.getItem('authToken');
  
  
    const setModalData = (status, id) => {
      setPropertyId(id)
      setShow(status)
  
    }
  
  
    const contactedProperty = async () => {
      try {
        const formData = new FormData();
  
  
        formData.append('property_id', propertyId);
        formData.append('user_id', user?.data?.id);
        formData.append('name', name);
        formData.append('mobile', phone);
        formData.append('activity_category', 'contacted_property');
        console.log(formData)
  
        // Example API call to save the profile data including the image
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/contactedProperty`, // Replace with your API URL
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Attach Bearer token
              'Content-Type': 'application/json', // Set correct content type for file upload
            },
          }
        );
  
  
        if (response.status) {
          setShow(false)
          setContactedId((prevContactedIds) => {
            const updatedIds = [...prevContactedIds, propertyId];
            return [...new Set(updatedIds)]; // Ensure uniqueness
          });
  
  
        }
      } catch (error) {
        console.error('Error updating:', error);
        alert('Something Went Wrong. Please try again.');
      }
    };
  
  
    const shortlistedProperty = async (id) => {
      try {
        const formData = new FormData();
  
  
        formData.append('property_id', id);
        formData.append('user_id', user?.data?.id);
        formData.append('name', user?.data?.name);
        formData.append('mobile', user?.data?.mobile);
        formData.append('activity_category', 'shortlisted_property');
        console.log(formData)
  
        // Example API call to save the profile data including the image
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/shortlistedProperty`, // Replace with your API URL
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Attach Bearer token
              'Content-Type': 'application/json', // Set correct content type for file upload
            },
          }
        );
  
  
        if (response.status) {
          setshortlistedId((prevContactedIds) => {
            const updatedIds = [...prevContactedIds, id];
            return [...new Set(updatedIds)]; // Ensure uniqueness
          });
  
  
        }
      } catch (error) {
        console.error('Error updating:', error);
        alert('Something Went Wrong. Please try again.');
      }
    };
  
  
    useEffect(() => {
      fetchSidebarData('rent');
    }, []);
  
    // Handle page change
    const handlePageChange = (newPage) => {
      if (newPage >= 1 && newPage <= paginationInfo.lastPage) {
        setPaginationInfo((prev) => ({ ...prev, currentPage: newPage }));
      }
    };
  
  
    const [show, setShow] = useState(false);
    const [propertyId, setPropertyId] = useState('');
    const [contactedId, setContactedId] = useState([]);
    const [shortlistedId, setshortlistedId] = useState([]);
    const [name, setName] = useState(user?.data?.name);
    const [phone, setPhone] = useState(user?.data?.mobile);
  
    const handleSubmit = (e) => {
      e.preventDefault();
      console.log("Name:", name);
      console.log("Phone:", phone);
      alert("Contact details submitted!");
    };
  
  
    const handleFilterChange = (type, field, event) => {
      const isChecked = event.target.checked; // Check if the checkbox is checked
  
      setFilters((prevFilters) => {
        const currentValues = prevFilters[field]?.split(',').filter(Boolean) || [];
  
        let updatedFilters;
        if (isChecked) {
          // Add the type if it is checked
          updatedFilters = {
            ...prevFilters,
            [field]: [...currentValues, type].join(','),
          };
        } else {
          // If unchecked, reset the field to include all possible values
          const allValues = getAllFilterValues(field); // Function to retrieve all possible filter values
          updatedFilters = {
            ...prevFilters,
            [field]: allValues.join(','), // Reset to all values
          };
        }
  
        console.log('Updated Filters:', updatedFilters); // Log the filters immediately after updating
        return updatedFilters; // Update the state with new filters
      });
    };
  
    // Example function to get all possible filter values
    const getAllFilterValues = (field) => {
      // Replace this logic with how you retrieve all possible values for the field
      if (field === 'exampleField') {
        return ['value1', 'value2', 'value3']; // Replace with actual values
      }
      return [];
    };
  return (
    <div className="d-flex mt-5 mb-5">
    <PropertySideBar />
     <div className="middleDiv ">
 
     <div className='property-section'>
 
 <div className='d-flex justify-content-between gap-3' >
 <div className='address-path d-flex justify-content-between w-100 '>
 <div className="d-flex gap-2">
 <span>Home</span>
 
 <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996" stroke="#343434" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
 </svg>
 </span>
 
 <span>Jaipur</span>
 
 <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996" stroke="#343434" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
 </svg>
 </span>
 
 <span className='last-path'>Flats for Sale in Jagatpura</span>
 </div>
 
 <div className='pagination '>
       Showing 1-30 of 1028
     </div>
 </div>
 
 
                 <div className=" border-bottom-0 d-flex">
             
                 <div className="dropdown border-bottom-0" >
                     <div className="dropdown-toggle1" style={{ width: '200px' }} onClick={toggleAccordion}>
                         <span>Sort</span>
                         <svg
                             width="21"
                             height="21"
                             viewBox="0 0 21 21"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg"
                         >
                             <path
                                 d="M18.8024 6.63184H2.13574"
                                 stroke="#1C274C"
                                 strokeWidth="1.5"
                                 strokeLinecap="round"
                             />
                             <path
                                 d="M16.3024 10.7988H4.63574"
                                 stroke="#1C274C"
                                 strokeWidth="1.5"
                                 strokeLinecap="round"
                             />
                             <path
                                 d="M13.8024 14.9658H7.13574"
                                 stroke="#1C274C"
                                 strokeWidth="1.5"
                                 strokeLinecap="round"
                             />
                         </svg>
                     </div>
                     {isOpen && (
                         <div
                             className="dropdown-menu-sort d-block position-absolute"
                             data-aos="fade-up"
                             data-aos-offset="200"
                             data-aos-duration="200"
                         >
                             <div
                                 className={`menu-item menu_item ${selectedItems.includes("Relevance") ? "selected" : ""}`}
                                 onClick={() => handleSelect("Relevance")}
                             >
                                 Relevance
                             </div>
 
                             <div
                                 className={`menu-item menu_item ${selectedItems.includes("Price Asc") ? "selected" : ""}`}
                                 onClick={() => handleSelect("Price Asc")}
                             >
                                 <span>Price</span>
                                 <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <path d="M5 18V23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M10 13V23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M15 8L15 23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M1 14.5C3.5 13.5 9.6 9.5 14 1.5M14 1.5L10.5 3.5M14 1.5V5" stroke="#343434" />
                                 </svg>
                             </div>
 
                             <div
                                 className={`menu-item menu_item ${selectedItems.includes("Price Desc") ? "selected" : ""}`}
                                 onClick={() => handleSelect("Price Desc")}
                             >
                                 <span>Price</span>
                                 <svg width="16" height="23" viewBox="0 0 16 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <path d="M11 17V22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M6 12L6 22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M1 7L1 22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M1.35962 0.359374C2.35962 2.85937 6.35962 8.95937 14.3596 13.3594M14.3596 13.3594L12.3596 9.85937M14.3596 13.3594L10.8596 13.3594" stroke="#343434" />
                                 </svg>
                             </div>
 
                             <div
                                 className={`menu-item menu_item ${selectedItems.includes("Area Asc") ? "selected" : ""}`}
                                 onClick={() => handleSelect("Area Asc")}
                             >
                                 <span>Area</span>
                                 <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <path d="M5 18V23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M10 13V23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M15 8L15 23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M1 14.5C3.5 13.5 9.6 9.5 14 1.5M14 1.5L10.5 3.5M14 1.5V5" stroke="#343434" />
                                 </svg>
                             </div>
 
                             <div
                                 className={`menu-item menu_item ${selectedItems.includes("Area Desc") ? "selected" : ""}`}
                                 onClick={() => handleSelect("Area Desc")}
                             >
                                 <span>Area</span>
                                 <svg width="16" height="23" viewBox="0 0 16 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <path d="M11 17V22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M6 12L6 22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M1 7L1 22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                     <path d="M1.35962 0.359374C2.35962 2.85937 6.35962 8.95937 14.3596 13.3594M14.3596 13.3594L12.3596 9.85937M14.3596 13.3594L10.8596 13.3594" stroke="#343434" />
                                 </svg>
                             </div>
 
                             <div
                                 className={`menu-item menu_item ${selectedItems.includes("Last Updated") ? "selected" : ""}`}
                                 onClick={() => handleSelect("Last Updated")}
                             >
                                 Last Updated
                             </div>
 
                             <div
                                 className={`menu-item menu_item_last ${selectedItems.includes("Date Added") ? "selected" : ""}`}
                                 onClick={() => handleSelect("Date Added")}
                             >
                                 Date Added
                             </div>
                         </div>
                     )}
                 </div>
                 </div>
             </div>
  
 
 
             {loading ? <LoadingSkeleton /> :
 
 
 <div className='main-area-contacted pt-2 pb-4 '  >
 
 
 <>
     {list?.length > 0 ? (
         list?.map((project, index) => (
             <>
                 <div className="list-card p-3 mb-4" key={index}>
 
 
                     <div className='d-flex'>
                         <div id={`customCarousel${index}`} className="carousel carousel-list slide" data-bs-ride="carousel">
 
                             {/* Carousel Indicators */}
                             <div className="carousel-indicators">
                                 {project?.images?.map((_, index) => (
                                     <button
                                         key={index}
                                         type="button"
                                         data-bs-target={`#customCarousel${index}`}
                                         data-bs-slide-to={index}
                                         className={index === 0 ? 'active propimgindicator' : 'propimgindicator'}
                                         aria-current={index === 0 ? 'true' : undefined}
                                         aria-label={`Slide ${index + 1}`}
                                     ></button>
                                 ))}
                             </div>
 
                             {/* Carousel Inner */}
                             <div className="carousel-inner">
                                 {project?.images?.map((image, index) => (
                                     <div
                                         key={index}
                                         className={`carousel-item ${index === 0 ? 'active' : ''}`}
                                     >
                                         <span className="rera">
                                         <svg width="68" height="26" viewBox="0 0 68 26" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M0 0H55C62.1797 0 68 5.8203 68 13C68 20.1797 62.1797 26 55 26H0V0Z" fill="black" fill-opacity="0.8"/>
 <path d="M16.216 18L13.892 14.01H12.352V18H11.078V8.242H14.228C14.9653 8.242 15.586 8.368 16.09 8.62C16.6033 8.872 16.986 9.21267 17.238 9.642C17.49 10.0713 17.616 10.5613 17.616 11.112C17.616 11.784 17.42 12.3767 17.028 12.89C16.6453 13.4033 16.0667 13.744 15.292 13.912L17.742 18H16.216ZM12.352 12.988H14.228C14.9187 12.988 15.4367 12.82 15.782 12.484C16.1273 12.1387 16.3 11.6813 16.3 11.112C16.3 10.5333 16.1273 10.0853 15.782 9.768C15.446 9.45067 14.928 9.292 14.228 9.292H12.352V12.988ZM20.8696 9.278V12.54H24.4256V13.59H20.8696V16.95H24.8456V18H19.5956V8.228H24.8456V9.278H20.8696ZM31.9113 18L29.5873 14.01H28.0473V18H26.7733V8.242H29.9233C30.6606 8.242 31.2813 8.368 31.7853 8.62C32.2986 8.872 32.6813 9.21267 32.9333 9.642C33.1853 10.0713 33.3113 10.5613 33.3113 11.112C33.3113 11.784 33.1153 12.3767 32.7233 12.89C32.3406 13.4033 31.762 13.744 30.9873 13.912L33.4373 18H31.9113ZM28.0473 12.988H29.9233C30.614 12.988 31.132 12.82 31.4773 12.484C31.8226 12.1387 31.9953 11.6813 31.9953 11.112C31.9953 10.5333 31.8226 10.0853 31.4773 9.768C31.1413 9.45067 30.6233 9.292 29.9233 9.292H28.0473V12.988ZM41.0589 15.83H36.8029L36.0189 18H34.6749L38.2029 8.298H39.6729L43.1869 18H41.8429L41.0589 15.83ZM40.6949 14.794L38.9309 9.866L37.1669 14.794H40.6949Z" fill="white"/>
 <g clip-path="url(#clip0_1330_4902)">
 <rect x="49" y="7" width="12" height="12" rx="6" fill="#00CC14"/>
 <path d="M51.541 13.958L53.9993 15.9163L58.4577 10.083" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
 </g>
 <defs>
 <clipPath id="clip0_1330_4902">
 <rect width="12" height="12" fill="white" transform="translate(49 7)"/>
 </clipPath>
 </defs>
 </svg>
 </span>
                                         <img
                                             src={`${process.env.REACT_APP_IMAGE_PATH}property/images/${image}`}
                                             className="d-block list-img"
                                             alt={`Slide ${index + 1}`}
 
                                         />
                                     </div>
                                 ))}
 
                              
                             </div>
                             {project?.images?.length == 0 ?
                             <div>
                                         <span className="rera">
                                         <svg width="68" height="26" viewBox="0 0 68 26" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M0 0H55C62.1797 0 68 5.8203 68 13C68 20.1797 62.1797 26 55 26H0V0Z" fill="black" fill-opacity="0.8"/>
 <path d="M16.216 18L13.892 14.01H12.352V18H11.078V8.242H14.228C14.9653 8.242 15.586 8.368 16.09 8.62C16.6033 8.872 16.986 9.21267 17.238 9.642C17.49 10.0713 17.616 10.5613 17.616 11.112C17.616 11.784 17.42 12.3767 17.028 12.89C16.6453 13.4033 16.0667 13.744 15.292 13.912L17.742 18H16.216ZM12.352 12.988H14.228C14.9187 12.988 15.4367 12.82 15.782 12.484C16.1273 12.1387 16.3 11.6813 16.3 11.112C16.3 10.5333 16.1273 10.0853 15.782 9.768C15.446 9.45067 14.928 9.292 14.228 9.292H12.352V12.988ZM20.8696 9.278V12.54H24.4256V13.59H20.8696V16.95H24.8456V18H19.5956V8.228H24.8456V9.278H20.8696ZM31.9113 18L29.5873 14.01H28.0473V18H26.7733V8.242H29.9233C30.6606 8.242 31.2813 8.368 31.7853 8.62C32.2986 8.872 32.6813 9.21267 32.9333 9.642C33.1853 10.0713 33.3113 10.5613 33.3113 11.112C33.3113 11.784 33.1153 12.3767 32.7233 12.89C32.3406 13.4033 31.762 13.744 30.9873 13.912L33.4373 18H31.9113ZM28.0473 12.988H29.9233C30.614 12.988 31.132 12.82 31.4773 12.484C31.8226 12.1387 31.9953 11.6813 31.9953 11.112C31.9953 10.5333 31.8226 10.0853 31.4773 9.768C31.1413 9.45067 30.6233 9.292 29.9233 9.292H28.0473V12.988ZM41.0589 15.83H36.8029L36.0189 18H34.6749L38.2029 8.298H39.6729L43.1869 18H41.8429L41.0589 15.83ZM40.6949 14.794L38.9309 9.866L37.1669 14.794H40.6949Z" fill="white"/>
 <g clip-path="url(#clip0_1330_4902)">
 <rect x="49" y="7" width="12" height="12" rx="6" fill="#00CC14"/>
 <path d="M51.541 13.958L53.9993 15.9163L58.4577 10.083" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
 </g>
 <defs>
 <clipPath id="clip0_1330_4902">
 <rect width="12" height="12" fill="white" transform="translate(49 7)"/>
 </clipPath>
 </defs>
 </svg>
 </span>
                                         <img
                                             src={noImage}
                                             className="d-block list-img"
                                             alt='...'
 
                                         />
                                     </div>
                                     :''
 
 }
                             {/* Carousel Controls */}
                             {/* <button
                                 className="carousel-control-prev"
                                 type="button"
                                 data-bs-target={`#customCarousel${index}`}
                                 data-bs-slide="prev"
                             >
                                 <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                 <span className="visually-hidden">Previous</span>
                             </button>
                             <button
                                 className="carousel-control-next"
                                 type="button"
                                 data-bs-target={`#customCarousel${index}`}
                                 data-bs-slide="next"
                             >
                                 <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                 <span className="visually-hidden">Next</span>
                             </button> */}
                         </div>
 
                         <div className='d-grid pt-2' style={{ width: '100%', paddingLeft: '15px' }}>
                             <div className="list-header cont-property-header">
                                 <div className="d-flex flex-grow-1">
                                     <h3>{project.project_name}</h3>
                                 </div>
                                 <div className='header-btntray1 d-flex' >
                                     <Link to="/">
                                         <div className="jump-icon" style={{ animationDelay: "0.2s" }}>
                                             <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                 <path d="M13.25 13.375H13.2588M13.6 10.75H14.125C14.9404 10.75 15.3481 10.75 15.6697 10.8832C16.0985 11.0608 16.4392 11.4015 16.6168 11.8303C16.75 12.1519 16.75 12.5596 16.75 13.375C16.75 14.1904 16.75 14.5981 16.6168 14.9197C16.4392 15.3485 16.0985 15.6892 15.6697 15.8668C15.3481 16 14.9404 16 14.125 16H3.625C2.80961 16 2.40191 16 2.0803 15.8668C1.65151 15.6892 1.31083 15.3485 1.13321 14.9197C1 14.5981 1 14.1904 1 13.375C1 12.5596 1 12.1519 1.13321 11.8303C1.31083 11.4015 1.65151 11.0608 2.0803 10.8832C2.40191 10.75 2.80961 10.75 3.625 10.75H4.15M8.875 11.625V2M8.875 11.625L6.25 9M8.875 11.625L11.5 9" stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                             </svg>
                                         </div>
                                     </Link>
                                     <Link to="/">
                                         <div className="jump-icon" style={{ animationDelay: "0.4s" }}>
                                             <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                 <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3746 3.66666C10.3746 2.1939 11.5932 1 13.0964 1C14.5996 1 15.8182 2.1939 15.8182 3.66666C15.8182 5.13942 14.5996 6.33334 13.0964 6.33334C12.3374 6.33334 11.6514 6.02877 11.1583 5.53878L7.39047 8.0636C7.42526 8.234 7.44355 8.41 7.44355 8.58976C7.44355 8.94576 7.37202 9.28608 7.24245 9.59712L11.3738 12.2686C11.8428 11.8929 12.4427 11.6666 13.0964 11.6666C14.5996 11.6666 15.8182 12.8606 15.8182 14.3334C15.8182 15.8061 14.5996 17 13.0964 17C11.5932 17 10.3746 15.8061 10.3746 14.3334C10.3746 13.9476 10.4585 13.5804 10.6093 13.2489L6.51129 10.599C6.03325 11.0078 5.40708 11.2564 4.72176 11.2564C3.21858 11.2564 2 10.0625 2 8.58976C2 7.11698 3.21858 5.92308 4.72176 5.92308C5.58614 5.92308 6.3556 6.3178 6.8538 6.93214L10.5054 4.48514C10.4205 4.22687 10.3746 3.95168 10.3746 3.66666Z" fill="#343434" />
                                             </svg>
                                         </div>
                                     </Link>
                                     <Link to="/">
                                         <div className="jump-icon" style={{ animationDelay: "0.6s" }}>
                                             <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                 <path d="M9.465 15.6077C9.21 15.6977 8.79 15.6977 8.535 15.6077C6.36 14.8652 1.5 11.7677 1.5 6.51769C1.5 4.20019 3.3675 2.3252 5.67 2.3252C7.035 2.3252 8.2425 2.9852 9 4.0052C9.38533 3.4846 9.88723 3.06149 10.4655 2.76975C11.0438 2.47802 11.6823 2.32576 12.33 2.3252C14.6325 2.3252 16.5 4.20019 16.5 6.51769C16.5 11.7677 11.64 14.8652 9.465 15.6077Z" stroke="#343434" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                             </svg>
                                         </div>
                                     </Link>
                                 </div>
                             </div>
 
                             <div className='property-pricing mt-3'>
                                 <span>₹ {formatPrice(project.property_price) + ' - ' + formatPrice(project.property_price)}</span>
                                 <span className='property-emi'>
                                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                         <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4688 0V14H1.53125V0H12.4688ZM5.03125 10.5H3.71875V11.8125H5.03125V10.5ZM7.65625 10.5H6.34375V11.8125H7.65625V10.5ZM10.2812 10.5H8.96875V11.8125H10.2812V10.5ZM5.03125 7.875H3.71875V9.1875H5.03125V7.875ZM7.65625 7.875H6.34375V9.1875H7.65625V7.875ZM10.2812 7.875H8.96875V9.1875H10.2812V7.875ZM5.03125 5.25H3.71875V6.5625H5.03125V5.25ZM7.65625 5.25H6.34375V6.5625H7.65625V5.25ZM10.2812 5.25H8.96875V6.5625H10.2812V5.25ZM11.1562 1.3125H2.84375V3.9375H11.1562V1.3125Z" fill="#EB622E" />
                                     </svg>
                                     (EMI starts at ₹36.59 K)
                                 </span>
                             </div>

                             <p className='property-description line-clamp'>
                                {project.project_description}
                            </p>
 
                             <div>
                                 <ul className='p-0 m-0 amenities-box mt-2'>
                                     <li>
                                         <div className="detail">
                                             <h5 className="detail-title">Furnishing</h5>
                                             <p className="detail-text">
                                                 {
                                                     project.furnish_type == 1
                                                         ? "Full Furnished"
                                                         : project.furnish_type == 2
                                                             ? "Semi Furnished"
                                                             : project.furnish_type == 3
                                                                 ? "Unfurnished"
                                                                 : "Not Specified"
                                                 }
 
                                             </p>
 
                                         </div>
                                     </li>
                                     <li>
                                         <div className="detail">
                                             <h5 className="detail-title">Average Price</h5>
                                             <p className="detail-text">₹6.5 K/sq.ft</p>
                                         </div>
                                     </li>
                                     <li>
                                         <div className="detail">
                                             <h5 className="detail-title">Sizes</h5>
                                             <p className="detail-text">{project.buildup_area} sq.ft.</p>
                                         </div>
                                     </li>
                                     <li>
                                         <div className="detail">
                                             <h5 className="detail-title">Locality</h5>
                                             <p className="detail-text">{project.locality_name}</p>
                                         </div>
                                     </li>
                                 </ul>
                             </div>
 
                             <div className="builder-info1 mt-2">
                                 <div className='builderimg'>
                                     <img src={builderlogo} alt="..." />
                                 </div>
                                 <div className='builder-info-detail justify-content-between'>
 
                                     <h5>{project.project_developer}</h5>
 
 
                                     {!contactedId.includes(project.id) ? (
                      <button
                        className="btn contseller-btn"
                        onClick={() => setModalData(true, project.id)}
                      >
                        Contact Seller
                      </button>
                    ) : 'Contacted'}
                                 </div>
 
 
 
                             </div>
                         </div>
 
                     </div>
 
 
 
                 </div>
               
             </>
         ))
     ) : <div>No Property Found</div>}
 
 </>
 </div>
 
    }
  <>

{/* Modal */}
{show && (
  <div
    className="modal show d-block"
    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Contact Seller</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShow(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form>
            {/* Name Input */}
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                id="name"
                className="form-control"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            {/* Phone Input */}
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">
                Phone
              </label>
              <div className="input-group">
                <span className="input-group-text">+91</span>
                <input
                  type="tel"
                  id="phone"
                  className="form-control"
                  placeholder="Enter your mobile number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
            </div>
            {/* Checkbox */}
            <div className="form-check mb-3">
              <input
                type="checkbox"
                id="agreement"
                className="form-check-input"
                required
              />
              <label htmlFor="agreement" className="form-check-label">
                I agree to be contacted via WhatsApp, SMS, phone, email,
                etc.
              </label>
            </div>
            {/* Submit Button */}
            <button type="button" className="btn btn-primary w-100" onClick={contactedProperty}>
              Get Contact Details
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
)}
</>
 </div>
     </div>
     <Advertisement />


     
</div>
  )
}

export default PropertyListPg
